import { styled, secondaryFontFamily } from '@openeducation/oe-rn-themes';
import { rgba } from 'polished';
import React, { memo } from 'react';

import HoverableButton from '../../atoms/hoverable-button/hoverable-button';
import { OEText } from '../../atoms/oe-text/oe-text';
import { ph, pv } from '../../style-utils';

export interface NavLinkProps {
  color: string;
  label: string;
  onPress?: () => void;
  spacing?: number;
  children?: (isHovered: boolean) => JSX.Element | null;
}

const NavLink = ({
  color,
  label,
  onPress,
  spacing = 20,
  children,
}: NavLinkProps) => {
  return (
    <HoverableButton
      onPress={onPress}
      style={[ph(spacing), pv(10)]}
      disabled={!onPress}
    >
      {(isHovered) => (
        <>
          <NavItemText isHovered={isHovered} color={color}>
            {label}
          </NavItemText>
          {children?.(isHovered)}
        </>
      )}
    </HoverableButton>
  );
};

type NavItemTextType = {
  isHovered: boolean;
  color: string;
};

const NavItemText = styled(OEText).attrs(
  ({ color, isHovered }: NavItemTextType) => ({
    fontType: 'medium',
    color: rgba(color, isHovered ? 0.85 : 1),
    fontSize: 16,
    fontFamily: secondaryFontFamily,
  })
)<NavItemTextType>``;

export default memo(NavLink);
